export default __webpack_public_path__ + "static/media/checkSmallTeal.0578c190.svg";